export var CandidateSignRoutes = {
    "/documents/:prospect_id?type&brandId": {
        "enableUTM": true,
        "name": "documents",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "component": "obCandidateSignPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["candidate_onboarding"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./candidate-sign.module.js");
                }
            }, {
                type: 'chunk',
                loader: function () {
                    return import("../../chat-bot/chat-bot.module.js");
                }
            }
        ],
        "onExit": ['localize', function (localize) {
            localize.enableLocale();
        }],
        "onEnter": ['localize', function (localize) {
            localize.disableLocale();
        }]
    },
    "/tl-documents/:prospect_id": {
        "enableUTM": true,
        "name": "appLayout.schedule.documents",
        "type": "frontend",
        "loginRequired": true,
        "showGlobalSearch": true,
        "views": {
            "body": {
                "component": "obCandidateSignPage"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["candidate_onboarding"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./candidate-sign.module.js");
                }
            }
        ],
        "onExit": ['localize', function (localize) {
            localize.enableLocale();
        }],
        "onEnter": ['localize', function (localize) {
            localize.disableLocale();
        }]
    },
    "/magicLink?token": {
        "name": "magic-link",
        "type": "frontend",
        "showGlobalSearch": false,
        "loginRequired": false,
        "onEnter": ['$stateParams', 'hUser', '$filter', function ($stateParams, hUser, $filter) {
            hUser.init().then(function () {
                if (hUser.isLoggedIn() && !hUser.isLoggedInWithMagicToken()) {
                    hAlert({
                        title: $filter("translate")("Something went wrong"),
                        text: $filter("translate")("To view your documents please log out from Harri and click the link again."),
                        custom_class: 'rejection-templates-error-alert',
                        button: {
                            text: $filter("translate")("Okay")
                        }
                    });
                } else {
                    CognitoUserManagerAPI.exchangeCustomToken($stateParams.token)
                        .then(function (response) {
                            HStorageManager.put({
                               storageLevel:  HStorageManager.StorageLevels.SESSION,
                                key: 'magicLinkToken',
                                value: response.data['access_token']
                            });
                            var redirectURL = response.data.meta_data['redirect_url'];
                            hRedirect(redirectURL);
                        })
                        .catch(function (err) {
                            console.error(err)
                            if (err.data.errors && err.data.errors.length) {
                                for (var i in err.data.errors) {
                                    var error = err.data.errors[i];
                                    if (['TOKEN_EXPIRED', 'TOKEN_EXCHANGE_LIMIT_EXCEEDED'].indexOf(error.detail?.code) > -1) {
                                        hAlert({
                                            title: $filter("translate")("Something went wrong"),
                                            text: $filter("translate")("Sorry, this link has expired."),
                                            custom_class: 'rejection-templates-error-alert',
                                            button: {
                                                text: $filter("translate")("Okay")
                                            }
                                        });
                                    } else {
                                        hAlert({
                                            title: $filter("translate")("Something went wrong"),
                                            text: error.detail.code,
                                            custom_class: 'rejection-templates-error-alert',
                                            button: {
                                                text: $filter("translate")("Okay")
                                            }
                                        });
                                    }
                                }
                            }
                        })
                }
            });

        }],
    },
};